import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { BoatLayoutContext } from '../components/Context/BoatLayoutContextProvider'
import { AuthorizationType } from '../types/authorization-types'

const hasPermission = (binaryValues, permission) => {
  let permissionSuccess = false
  binaryValues.map(binaryValue => {
    if (binaryValue && permission && (BigInt(binaryValue) & BigInt(permission)) == BigInt(binaryValue)) {
      permissionSuccess = true
    }
  })

  return permissionSuccess
}

export { hasPermission }
//Permission value validation function
const validateAuthorization = (WrappedComponent, context, binaryValues, props, type, t) => {
  let permissionSuccess = false
  binaryValues.map(binaryValue => {
    if (
      binaryValue &&
      context?.permission &&
      (BigInt(binaryValue) & BigInt(context?.permission)) == BigInt(binaryValue)
    ) {
      permissionSuccess = true
    }
  })

  if (permissionSuccess) {
    return <WrappedComponent {...props} />
  } else if (type == AuthorizationType.Page) {
    return (
      <Typography
        variant="h5"
        style={{ color: 'rgba(40,40,40,.3)', width: '100%', textAlign: 'center', marginTop: 20 }}
      >
        {t('page-not-authorize')}
      </Typography>
    )
  } else if (type == AuthorizationType.Disabled) {
    return (
      <WrappedComponent
        to={window.location.pathname}
        onClick={() => {}}
        style={{ pointerEvents: 'none', cursor: 'not-allowed', color: 'rgba(0, 0, 0, 0.26)' }}
        {...props}
        disabled
      />
    )
  } else if (type == AuthorizationType.Feature) {
    return (
      <Typography
        variant="h5"
        style={{ color: 'rgba(40,40,40,.3)', width: '100%', textAlign: 'center', marginTop: 20 }}
      >
        {t('feature-not-authorize')}
      </Typography>
    )
  } else {
    return null
  }
}

//HOC for authorization with context(indirect permission)
const indirectAuthorization = (WrappedComponent, binaryValues: number[], type = null, Context = null, translation) => {
  return class extends React.Component<any> {
    constructor(props) {
      super(props)
    }
    render() {
      const AuthContext = Context ? Context : BoatLayoutContext
      return (
        <AuthContext.Consumer>
          {context => validateAuthorization(WrappedComponent, context, binaryValues, this.props, type, translation)}
        </AuthContext.Consumer>
      )
    }
  }
}

//HOC for authorization with direct permission
export const directAuthorization = (WrappedComponent, binaryValues: number[], type = null, permission, translation) => {
  return class extends React.Component<any> {
    constructor(props) {
      super(props)
    }
    render() {
      return validateAuthorization(
        WrappedComponent,
        { permission: permission },
        binaryValues,
        this.props,
        type,
        translation,
      )
    }
  }
}
//translation binding for indirect authorization
const authorization = (WrappedComponent, binaryValues: number[], type = null, Context = null) => {
  return (props: any) => {
    const { t } = useTranslation('authorization')
    const Component = indirectAuthorization(WrappedComponent, binaryValues, type, Context, t)
    return <Component {...props} />
  }
}
//translation binding for direct authorization
export const authorizationWithDirectPermission = (
  WrappedComponent,
  binaryValues: number[],
  type = null,
  permission,
) => {
  return (props: any) => {
    const { t } = useTranslation('authorization')
    const Component = directAuthorization(WrappedComponent, binaryValues, type, permission, t)
    return <Component {...props} />
  }
}

export default authorization

interface IAuthorizationWrapper {
  permissions?: number[]
  type?: AuthorizationType
  Context?: any
  self_auth?: boolean
  permission?: number
  children: JSX.Element // Wrapper only accepts one child
}
//Wrapper Component for authorization
export const AuthorizationProvider = ({
  permissions = null,
  type = AuthorizationType.Disabled,
  Context = null,
  self_auth = false,
  permission = null,
  children,
}: IAuthorizationWrapper) => {
  const { t } = useTranslation('authorization')

  const Element = useMemo(() => {
    if (self_auth) {
      return directAuthorization(children.type, permissions, type, permission, t)
    } else {
      return indirectAuthorization(children.type, permissions, type, Context, t)
    }
  }, [permission, t])

  if (permissions === null) {
    return children
  }

  return Element ? <Element {...children.props} /> : <></>
}
